import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-background via-card to-background py-16 md:py-24 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-10 w-64 h-64 bg-primary rounded-full blur-3xl" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-accent rounded-full blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="space-y-6 md:space-y-8">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20">
              <div className="w-2 h-2 rounded-full bg-success animate-pulse-glow" />
              <span className="text-sm font-medium text-primary">Available for Projects</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold font-heading text-foreground leading-tight">
              Building Solutions That
              <span className="block text-primary mt-2">Drive Real Results</span>
            </h1>

            <p className="text-base md:text-lg lg:text-xl text-muted-foreground leading-relaxed max-w-2xl">
              I'm Oforka Michael Chinonso (MR MIKE), a full-stack developer who bridges the gap between technical excellence and business impact. I don't just write code—I architect scalable solutions that solve real-world problems and deliver measurable outcomes.
            </p>

            <div className="flex flex-wrap gap-4">
              <div className="flex items-center gap-3 px-4 py-3 rounded-lg bg-card border border-border">
                <Icon name="Award" size={24} className="text-primary" />
                <div>
                  <div className="text-2xl font-bold text-foreground">5+</div>
                  <div className="text-sm text-muted-foreground">Years Experience</div>
                </div>
              </div>
              <div className="flex items-center gap-3 px-4 py-3 rounded-lg bg-card border border-border">
                <Icon name="Rocket" size={24} className="text-primary" />
                <div>
                  <div className="text-2xl font-bold text-foreground">50+</div>
                  <div className="text-sm text-muted-foreground">Projects Delivered</div>
                </div>
              </div>
              <div className="flex items-center gap-3 px-4 py-3 rounded-lg bg-card border border-border">
                <Icon name="Users" size={24} className="text-primary" />
                <div>
                  <div className="text-2xl font-bold text-foreground">30+</div>
                  <div className="text-sm text-muted-foreground">Happy Clients</div>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden border-4 border-primary/20 shadow-2xl">
              <Image
                src="https://img.rocket.new/generatedImages/rocket_gen_img_16073ccd5-1766925322121.png"
                alt="Professional African developer Oforka Michael Chinonso working on laptop in modern office with dual monitors showing code and design interfaces"
                className="w-full h-[400px] md:h-[500px] lg:h-[600px] object-cover" />

              <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-transparent to-transparent" />
            </div>

            <div className="absolute -bottom-6 -right-6 bg-card border border-border rounded-xl p-4 md:p-6 shadow-xl max-w-xs">
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
                  <Icon name="Code2" size={24} className="text-primary" />
                </div>
                <div>
                  <div className="text-sm font-medium text-muted-foreground">Core Philosophy</div>
                  <div className="text-base font-bold text-foreground mt-1">Results Over Rhetoric</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default HeroSection;